/*@ngInject*/
const HideSharedCollaborationRepository = function (baseRepository) {

    angular.extend(this, baseRepository);

    this.hideSharedCollaboration = function (submissionId) {
        let url = '/rest/Submission/' + submissionId + '/hideSharedCollaboration';
        return this.post(url);
    };

};

angular.module('gw-um-submission')
    .service('hideSharedCollaborationRepository', HideSharedCollaborationRepository);
